import React, { FC } from "react";
import { useTranslation } from "react-i18next";

import { Typography } from "~/ui-kit/components/Typography/Typography";
import { ClimateLeafMark } from "~/components/common/ClimateLeafMark/ClimateLeafMark";

export type ClimateCompensationCardProps = {
  merchantName: string;
};

export const ClimateCompensationCard: FC<ClimateCompensationCardProps> = ({
  merchantName,
}) => {
  const { t } = useTranslation();
  return (
    <div className="card">
      <div className="card-body">
        <div className="d-flex align-items-center">
          <div className="me-4">
            <ClimateLeafMark />
          </div>
          {/* Currently using Trans component from react-i18next (which supports HTML tags interpolation)
            does not work as expected, as it does not re-render on language change
            So we're using the text CO2 with <sub /> component
            TODO: Investigate how to properly display CO2 with subscript while ensuring re-render
          */}
          <Typography size="sm" weight="rg" className="grey-500-c">
            {t("backend:climate", {
              merchantName,
            })}
          </Typography>
        </div>
      </div>
    </div>
  );
};
